module.exports = __webpack_public_path__ + "media/images/etyekilogo-etyeki-60x60-af074f01d677fc2c7a3ca9b54d3664c4.png";